module.exports = __webpack_public_path__ + "img/01.094be3c3.jpg";